import { convertToValidOpeningHours } from '../../../pages/adapters/convert-to-valid-opening-hours.js';
import { ACCESSIBILITY_WHEELCHAIR, FRANCHISE_STORE } from '../../../types.js';

const mapStoreResult = (item)=>{
    const inventory = 'inventory' in item ? item.inventory : undefined;
    const productReservability = 'productReservability' in item ? item.productReservability : undefined;
    const appointmentTypes = 'appointmentTypes' in item ? item.appointmentTypes : undefined;
    const storeOffers = 'offers' in item ? item.offers : undefined;
    const accessibility = item.accessibility || [];
    const storeTypes = item.storeTypes || [];
    var _slug, _storenote, _streetNumber, _additionalStreetInfo, _postalCode, _province, _lat, _lon, _email, _servicesNotAvailable, _specialOpenClosingHours, _hearingAppointmentPossible, _weekendOpen, _totalQuantity, ref;
    return {
        code: item.code,
        name: item.name,
        shortName: item.shortName,
        streetName: item.streetName,
        town: item.town,
        country: item.country,
        phone: item.phone,
        slug: (_slug = item.slug) !== null && _slug !== void 0 ? _slug : undefined,
        storeNote: (_storenote = item.storenote) !== null && _storenote !== void 0 ? _storenote : undefined,
        streetNumber: (_streetNumber = item.streetNumber) !== null && _streetNumber !== void 0 ? _streetNumber : undefined,
        additionalStreetInfo: (_additionalStreetInfo = item.additionalStreetInfo) !== null && _additionalStreetInfo !== void 0 ? _additionalStreetInfo : undefined,
        postalCode: (_postalCode = item.postalCode) !== null && _postalCode !== void 0 ? _postalCode : undefined,
        province: (_province = item.province) !== null && _province !== void 0 ? _province : undefined,
        lat: (_lat = item.lat) !== null && _lat !== void 0 ? _lat : undefined,
        lon: (_lon = item.lon) !== null && _lon !== void 0 ? _lon : undefined,
        emailAddress: (_email = item.email) !== null && _email !== void 0 ? _email : undefined,
        distance: item.distance,
        servicesNotAvailable: (_servicesNotAvailable = item.servicesNotAvailable) !== null && _servicesNotAvailable !== void 0 ? _servicesNotAvailable : [],
        openingHours: {
            monday: convertToValidOpeningHours(item.monOpenClose),
            tuesday: convertToValidOpeningHours(item.tueOpenClose),
            wednesday: convertToValidOpeningHours(item.wedOpenClose),
            thursday: convertToValidOpeningHours(item.thuOpenClose),
            friday: convertToValidOpeningHours(item.friOpenClose),
            saturday: convertToValidOpeningHours(item.satOpenClose),
            sunday: convertToValidOpeningHours(item.sunOpenClose)
        },
        specialOpeningHours: ((_specialOpenClosingHours = item.specialOpenClosingHours) !== null && _specialOpenClosingHours !== void 0 ? _specialOpenClosingHours : []).filter((x)=>x !== null
        ),
        wheelchairAccessible: accessibility.includes(ACCESSIBILITY_WHEELCHAIR),
        hearingAppointmentPossible: (_hearingAppointmentPossible = item.hearingAppointmentPossible) !== null && _hearingAppointmentPossible !== void 0 ? _hearingAppointmentPossible : false,
        weekendOpen: (_weekendOpen = item.weekendOpen) !== null && _weekendOpen !== void 0 ? _weekendOpen : false,
        stock: inventory ? {
            status: inventory.stockIndicator,
            quantity: (_totalQuantity = inventory.totalQuantity) !== null && _totalQuantity !== void 0 ? _totalQuantity : undefined,
            showroomModelAvailable: inventory.items.some((x)=>x.showroomModelAvailable
            )
        } : undefined,
        inStoreReservable: (ref = productReservability === null || productReservability === void 0 ? void 0 : productReservability.inStoreReservable) !== null && ref !== void 0 ? ref : false,
        appointmentTypes: appointmentTypes === null || appointmentTypes === void 0 ? void 0 : appointmentTypes.map((appointmentType)=>({
                id: appointmentType.id,
                isAvailableInStore: appointmentType.isAvailableInStore
            })
        ),
        offers: storeOffers,
        isFranchiseStore: storeTypes.includes(FRANCHISE_STORE)
    };
};
const mapStoresResult = (storeSearchQueryData)=>{
    if (!storeSearchQueryData) {
        return null;
    }
    try {
        return storeSearchQueryData.map(mapStoreResult);
    } catch (e) {
        console.error('Store search query data adapter failed to parse input data correctly.', e, storeSearchQueryData);
        return null;
    }
};
var mapStoresResult$1 = mapStoresResult;

export { mapStoresResult$1 as default, mapStoreResult, mapStoresResult };
//# sourceMappingURL=mapStoresResult.js.map
